module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-30.bda565fc.svg";